<template>
  <b-row>
    <b-col md="12" class="mb-3">
      <div class="package-name-background text-white p-2"><p>{{title}}</p></div>
      <b-row>
        <b-col sm="5">
          <h6 class="package-title my-3">Detaliere pret</h6>
          <b-card no-body>
            <b-table-simple class="table-sm mb-0">
              <b-tr>
                <b-th class="bg-light">Total client</b-th>
                <b-td class="text-primary">{{ meal.price + meal.tax + serviceTax  }}</b-td>
              </b-tr>
              <b-tr>
                <b-th class="bg-light">Taxe</b-th>
                <b-td>{{ meal.tax + serviceTax }}</b-td>
              </b-tr>
              <b-tr>
                <b-th class="bg-light">Comision</b-th>
                <b-td class="text-danger">{{ meal.commission + serviceTax }}</b-td>
              </b-tr>
              <b-tr>
                <b-th class="bg-light">Total de plata</b-th>
                <b-td class="text-success">{{ meal.price + meal.tax - meal.commission }}</b-td>
              </b-tr>
            </b-table-simple>
            <b-table-simple class="table-sm mb-0" v-if="paymentSchedule && paymentSchedule.length">
              <b-tr>
                <b-td colspan="2">
                  <h6 class="package-title my-1"><small><b>Termene de plata</b></small></h6>
                </b-td>
              </b-tr>
              <b-tr v-for="(dd, ddIndex) in paymentSchedule" :key="'dd' + ddIndex">
                <b-th class="bg-light">{{ formatDate(dd.date) }} </b-th>
                <b-td class="text-success">{{ ceil(dd.amount) || 'diferenta' }}</b-td>
              </b-tr>
            </b-table-simple>
          </b-card>
        </b-col>
        <b-col sm="7">
          <h6 class="package-title my-3">Discounturi aplicate</h6>
          <b-card class="bg-light">
            <div v-for="(discount, packDiscount) in discounts" :key="packDiscount">
              <span class="package-title mb-2 d-block" style="font-size:.8rem;">{{discount.label}}</span>

              <p v-if="discount.bookingFrom || discount.bookingTo" class="mb-0"><b>Valabilitate oferta:&nbsp;</b>
                <span v-if="!discount.bookingFrom && !discount.bookingTo">oricare</span>
                <span v-if="discount.bookingFrom && !discount.bookingTo"> de la {{ discount.bookingFrom}}</span>
                <span v-if="!discount.bookingFrom && discount.bookingTo"> pana la {{ discount.bookingTo }}</span>
                <span v-if="discount.bookingFrom && discount.bookingTo"> intre {{ discount.bookingFrom }} si {{ discount.bookingTo }}</span>
              </p>
              <hr class="my-1">
              <p class="mb-0"><b>Date calatorie:&nbsp;</b>
                <span v-if="!discount.travelFrom && !discount.travelTo">oricare</span>
                <span v-if="discount.travelFrom && !discount.travelTo"> de la {{ discount.travelFrom}}</span>
                <span v-if="!discount.travelFrom && discount.travelTo"> pana la {{ discount.travelTo }}</span>
                <span v-if="discount.travelFrom && discount.travelTo"> intre {{ discount.travelFrom }} si {{ discount.travelTo }}</span>
              </p>
              <hr class="my-1">
              <p class="m-0"><span class="text-danger">{{discount.description}}</span></p>
            </div>
            <p class="m-0" v-if="discounts.length == 0">Nu au fost aplicate discounturi</p>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import moment from 'moment'

export default {
  name: 'PriceDetails',
  props: {
    title: String,
    meal: {
      type: Object,
      required: true
    },
    discounts: {
      type: Array,
      required: false,
      default: () => { return [] }
    },
    serviceTax: {
      type: Number,
      required: false,
      default: 0
    },
    paymentSchedule: {
      type: Array,
      required: false,
      default: () => { return [] }
    }
  },
  methods: {
    formatDate (d) {
      return moment(d, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    ceil (no) {
      return Math.ceil(no)
    }
  }
}
</script>
